import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  Alert,
  Stack,
  Box,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import { DAY_LABELS, days, FREQUENCY_LABELS, weeks } from "../../../../../const/day.const";
import ButtonUI from "../../../../../components/button/buttons";
import BasicSelect from "../../../../../components/inputs/selectInput";

interface DispersalModalProps {
  open?: boolean;
  onClose?: () => void;
  data?: any;
  bank?: unknown;
  handleBank?: (event: SelectChangeEvent) => void;
  dataBank?: unknown;
  setAmountType?: any;
  amountType?: string;
  handleChangeFrequency?: any;
  frequency?: string;
  handleChangePayDay: (event: SelectChangeEvent) => void;
  payDay?: string;
  onClick?: () => void;
  loading?: boolean;
}

export const AutomaticWithdrawalModal: React.FC<DispersalModalProps> = ({
  data,
  bank,
  handleBank,
  dataBank,
  setAmountType,
  amountType,
  handleChangeFrequency,
  handleChangePayDay,
  frequency,
  payDay,
  onClick,
  loading
}) => {
  const [specificAmount, setSpecificAmount] = useState(5500);

  return (
    <>
      {/* <Box mb={3} p={3} borderRadius={2} bgcolor="#F4FBF6" textAlign="center">
        <Typography variant="subtitle2" color="text.secondary">
          TOTAL A DISPERSAR
        </Typography>
        <Typography variant="h4" color="success.main" fontWeight={700}>
          {data || 0}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Basado en tu monto personalizado
        </Typography>
      </Box> */}

      <Stack spacing={2}>
        <FormControl>
          <FormLabel>Monto</FormLabel>
          <RadioGroup
            row
            value={amountType}
            onChange={(e) => setAmountType(e.target.value)}
          >
            <FormControlLabel
              value="full"
              control={<Radio />}
              label="Saldo completo"
            />
            {/* <FormControlLabel
              value="custom"
              control={<Radio />}
              label="Cantidad personalizada"
            /> */}
          </RadioGroup>
        </FormControl>

        {amountType === "custom" && (
          <TextField
            label="Monto específico"
            type="number"
            value={specificAmount}
            onChange={(e) => setSpecificAmount(Number(e.target.value))}
            fullWidth
          />
        )}
        {/* 
        {specificAmount > data && (
          <Alert severity="warning">
            Saldo insuficiente. Tu saldo disponible es $
            {data?.toLocaleString()}
          </Alert>
        )} */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Frecuencia</InputLabel>
          <Select
            label="Frecuencia"
            onChange={handleChangeFrequency}
            value={frequency}
          >
            {weeks.map((week) => (
              <MenuItem key={week} value={week}>

                {FREQUENCY_LABELS[week]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {frequency === "weekly" && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Día de Pago</InputLabel>
            <Select
              label="Día de Pago"
              onChange={handleChangePayDay}
              value={payDay}
            >
              {days.map((day) => (
                <MenuItem key={day} value={day}>
                  
                  {DAY_LABELS[day]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {frequency === "monthly" && (
          <Alert>
            <span>
              El saldo se retirará <strong>automáticamente</strong> el primer
              día de cada mes.
            </span>
          </Alert>
        )}
        <BasicSelect
          value={bank}
          handleChange={handleBank}
          data={dataBank ?? []}
          label="Cuenta de retiro"
          labelInput="Cuenta"
          id="select-account"
        />

        <ButtonUI
          color="primary"
          fullWidth
          variant="contained"
          title=" Programar Dispersion"
          disabled={!bank}
          onClick={onClick}
          loading={loading}
          //onClick={openModal}
        />
      </Stack>
    </>
  );
};
